import React, { memo } from 'react';
import './ShareSessionLoader.scss';
import { Loading } from '@web-components-proxy';

export const ShareSessionLoader = memo(() => {
	return <Loading class="share-session-loader" active={true} loader-size="medium"></Loading>;
});
